module.exports = __webpack_public_path__ + "media/assets/images/connectors/nexthink-logo-719d0f23cce4f8775badc21abde1c944.png";